module.exports = __webpack_public_path__ + "media/images/lb/461-88f19c23e276f2d8505f081eefc66c17.svg";